import FollowUpSummary from './FollowUpSummary'

export default FollowUpSummary
